import { render, staticRenderFns } from "./ControlActionHistories.v2.vue?vue&type=template&id=90ede734&scoped=true"
import script from "./ControlActionHistories.v2.vue?vue&type=script&lang=js"
export * from "./ControlActionHistories.v2.vue?vue&type=script&lang=js"
import style0 from "./ControlActionHistories.v2.vue?vue&type=style&index=0&id=90ede734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ede734",
  null
  
)

export default component.exports